import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Grid, Box } from '@material-ui/core';
import styled from 'styled-components';
import api from 'api';
import { Button } from 'catalyst/core';
import PropTypes from 'prop-types';
import { ToastsStore } from 'react-toasts';

const MAX_BYTE_UPLOAD_SIZE = 41943040;

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border 0.24s ease-in-out;
`;

const Upload = ({ addFiles }) => {
    const [myFiles, setMyFiles] = useState([]);
    const [uploading, setUploading] = useState(false);

    const onDrop = useCallback(
        (acceptedFiles) => {
            setMyFiles([...myFiles, ...acceptedFiles]);
        },
        [myFiles]
    );

    const { acceptedFiles, getRootProps, getInputProps, fileRejections } =
        useDropzone({
            accept: '.pdf',
            maxSize: MAX_BYTE_UPLOAD_SIZE,
            maxFiles: 10,
            onDrop,
        });

    const files = myFiles.map((file) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const fileRejectionItems = fileRejections.map(({ file, errors }) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
            <ul>
                {errors.map((e) => (
                    <li key={e.code}>{e.message}</li>
                ))}
            </ul>
        </li>
    ));

    const uploadFile = () => {
        setUploading(true);
        let formData = new FormData();
        myFiles.forEach((file) => {
            formData.append('uploadedFiles', file);
        });
        api.jsr
            .uploadFile(formData)
            .then((response) => {
                addFiles(response);
                setUploading(false);
                setMyFiles([]);
            })
            .catch((err) => {
                console.error(err);
                setUploading(false);
                ToastsStore.error(
                    'Something went wrong uploading your file, please try again.'
                );
            });
    };

    return (
        <div className="container">
            <Container {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <p>Drag &amp; drop files here, or click to select files</p>
            </Container>
            <Grid container>
                <Grid item xs={12}>
                    {myFiles.length > 0 ? (
                        <>
                            <Box pt={2} pb={2}>
                                <h4>Selected files</h4>
                                <ul>{files}</ul>
                            </Box>
                            <Button
                                onClick={uploadFile}
                                loading={uploading}
                                variant="contained"
                            >
                                Upload file
                            </Button>
                        </>
                    ) : null}
                </Grid>
                <Grid item xs={12}>
                    {fileRejectionItems.length > 0 ? (
                        <Box pt={2} pb={2}>
                            <h4>Rejected files</h4>
                            <ul>{fileRejectionItems}</ul>
                        </Box>
                    ) : null}
                </Grid>
            </Grid>
        </div>
    );
};

Upload.propTypes = {
    addFiles: PropTypes.func.isRequired,
};

export default Upload;
